module.exports = __webpack_public_path__ + "img/lfu.42f3ae05.png";